export default "__VITE_PUBLIC_ASSET__ade8c348__"